export default __webpack_public_path__ + "ae8ef7b59a17370234e23e1bf76d06b5.woff";